import {createContext, useContext} from 'react';
import type {RatingRadioGroupSize} from './types';

type RatingRadioGroupContextValue = {
  name: string;
  value: number;
  size: RatingRadioGroupSize;
  hoverValue?: number;
  onChange?: (value: number) => void;
  onMouseLeave: () => void;
  onMouseEnter: (value: number) => void;
  onTouchStart: (value: number) => void;
  onTouchEnd: () => void;
};

const RatingRadioGroupContext = createContext<RatingRadioGroupContextValue | null>(null);

export const RatingRadioGroupProvider = RatingRadioGroupContext.Provider;

export function useRatingRadioGroupContext() {
  const context = useContext(RatingRadioGroupContext);

  if (!context) {
    throw new Error(
      'RatingRadioGroup compound components must be used inside RatingRadioGroup.',
    );
  }

  return context;
}
